import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import {
  Grid,
  Select,
} from 'semantic-ui-react';

import Fetcher from '../reusable/Fetcher';
import FloorPlan from './FloorPlan';

const selectedHallKey = 'Overview/SelectedHall';

class Overview extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    getOrganisationHalls: PropTypes.func.isRequired,
    halls: PropTypes.shape({}).isRequired,
    currentOrganisation: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedHall: localStorage.getItem(selectedHallKey),
    };
  }

  hallSelected = (ev, data) => {
    const selectedHall = data.value;
    localStorage.setItem(selectedHallKey, selectedHall);
    this.setState({ selectedHall });
  };

  render() {
    const { selectedHall } = this.state;
    const {
      t, getOrganisationHalls, halls, currentOrganisation,
    } = this.props;
    const options = halls.allIds.map(id => ({
      key: id,
      text: halls.byId[id].name,
      value: halls.byId[id].name,
    }));

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <span>{t('overview.intro')}</span>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Fetcher fetchAction={getOrganisationHalls} isLoading={halls.isPending}>
              <Select
                width={2}
                options={options}
                placeholder={t('overview.select-hall')}
                value={selectedHall}
                onChange={this.hallSelected}
              />
            </Fetcher>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="center">
            {halls.allIds.map((id) => {
              if (halls.byId[id].name === selectedHall) {
                return (
                  <FloorPlan
                    key={id}
                    hall={halls.byId[id]}
                    imageUrl={halls.byId[id].imageUrl}
                    currentOrganisation={currentOrganisation}
                  />
                );
              }
              return <Fragment key={id} />;
            })}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default translate()(Overview);



// WEBPACK FOOTER //
// ./src/components/Overview/Overview.js